// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import auth0VerifyChangeEmail from "@west/App/Handlers/AccountSettings/Auth0VerifyChangeEmail";
import { getChangeEmailVerifiedToken } from "@west/App/Store/Selectors/Auth0Selectors";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        accountSettingsPageLink: getPageLinkByPageType(state, "AccountSettingsPage"),
        auth0Config: getChangeEmailVerifiedToken(state),
    };
};

const mapDispatchToProps = {
    auth0VerifyChangeEmail,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ChangeEmailPage: FC<Props> = ({ id, accountSettingsPageLink, auth0Config, auth0VerifyChangeEmail }) => {
    const history = useHistory();

    const redirectToAccountSettingsPage = () => {
        if (accountSettingsPageLink?.url) {
            history.replace(accountSettingsPageLink?.url);
        }
    };

    useEffect(() => {
        const { idToken, state } = auth0Config;

        if (!idToken || !state) {
            redirectToAccountSettingsPage();
            return;
        }

        auth0VerifyChangeEmail({
            idToken,
            state,
            onSuccess: r => {
                if(!r || !r.valid)
                    redirectToAccountSettingsPage();
            },
            onError: _ => {
                redirectToAccountSettingsPage();
            }
        });
    }, []);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ChangeEmailPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};
export default pageModule;
